<template>
  <div class="table-action-wrapper scan-and-print-tracking" ref="container">
    <div style="width: 350px">
      <div class="d-flex align-items-center">
        <span class="pr-2">Action:</span>
        <Select :options="Object.values(scanAndActionOptions)" data-title="Action" class="has-tip d-inline-block" v-model="action" style="width: 250px"></Select>
      </div>
      <div class="item-selected mb-0 mt-2">ID: {{ id || 'Listening' }}</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      id: '',
      action: 'find',
      debounce: {
        submit: _.debounce(this.submit, 300)
      }
    }
  },
  mounted() {
    document.addEventListener('keydown', this.scanning)
  },
  unmounted() {
    document.removeEventListener('keydown', this.scanning)
  },
  computed: {
    extraAttributes() {
      return this.config?.extraAttributes || {}
    },
    scanAndActionOptions() {
      return this.extraAttributes?.scan_and_action || {}
    }
  },
  methods: {
    scanning(e) {
      if (!document.hasFocus() || ['INPUT', 'TEXTAREA', 'SELECT', 'BUTTON'].includes(document.activeElement.tagName) || document.activeElement.isContentEditable) {
        return false
      }
      if (/^[0-9a-zA-Z=]$/.test(e.key)) {
        this.id += String(e.key)
        this.debounce.submit(this.id)
      }
    },
    async submit() {
      if (this.action == 'make_verified') {
        await this.submitMakeVerified()
      } else if (this.action != 'find') {
        await this.submitChangeStatus()
      }
      this.$emit('change-filters', { search: this.id, search_by: null }, { refresh: true, goToFirst: true })
      this.id = ''
    },
    async submitMakeVerified() {
      return this.$util.post(`manufacture/verify/${this.id}`, {}, this.$refs.container)
    },
    async submitChangeStatus() {
      return this.$util.post(`manufacture/update-status/${this.id}`, { status: this.action }, this.$refs.container)
    }
  },
  props: {
    config: Object
  }
}
</script>
